import {
  GET_LENOVOWORDS_SEARCH_SUCCESS,
  GET_RESULT_SEARCH_SUCCESS,
  GET_SEARCH_RECOMMEND_SUCCESS,
  CLEAN_SEARCH_RECOMMEND_SUCCESS,
  SET_FEEDBACK_VISIBLE,
  SET_HOT_SEARCH_BOX,
  SET_IS_SEARCH_CLICK,
} from '../constants/search';

const initState = {
  hotSearch: [],
  hotSearchApp: [],
  searchBarWordList: {},
  searchResult: null,
  lenovoWords: {},
  searchRecommend: {},
  feedbackVisible: false,
  isSearchClick: false,
};

const search = (state = initState, action = {}) => {
  switch (action.type) {
    case GET_LENOVOWORDS_SEARCH_SUCCESS:
      return { ...state, lenovoWords: action.payload };
    case GET_RESULT_SEARCH_SUCCESS:
      return { ...state, searchResult: action.payload };
    case GET_SEARCH_RECOMMEND_SUCCESS:
      return { ...state, searchRecommend: action.payload };
    case CLEAN_SEARCH_RECOMMEND_SUCCESS:
      return { ...state, searchRecommend: action.payload };
    case SET_FEEDBACK_VISIBLE:
      return { ...state, feedbackVisible: action.payload.feedbackVisible };
    case SET_HOT_SEARCH_BOX:
      return {
        ...state,
        hotSearch: action.payload.hotWordList,
        hotSearchApp: action.payload.hotWordAppList,
        searchBarWordList: action.payload.searchBarWordList,
      };
    case SET_IS_SEARCH_CLICK:
      return {
        ...state,
        isSearchClick: action.payload,
      };
    default:
      return state;
  }
};

export default search;
